import { bamIdSelector } from "@redux/room/selectors";
import { setIsVideoRecording } from "@redux/session";
import {
	bamSessionClientCodeSelector,
	isVideoRecordingSelector,
} from "@redux/session/selectors";
import { useDispatch, useSelector } from "react-redux";

import {
	CHARSETS,
	HTTPrequestContentTypes,
	HttpRequestVerbs,
} from "constants/network";

import {
	saveImageOrVideoDataEndPoint,
	startRecordingVideoEndPoint,
	stopRecordingVideoAndSaveItEndPoint,
	takePictureEndPoint,
} from "./cameraAdreses";
import { PlayerEvent } from "shared-types/player-event";
import { sendMultiScreenEventToTv } from "services/helpers/multiScreen";

const CAMERA_REQUEST_FAILED_ERROR =
	"Sorry, we couldn't reach your webcam software";

export type CredentialsToSend = { roomId?: string; clientCode?: string };

export const takePicture = async (clientCode: string) => {
	try {
		await fetch(takePictureEndPoint, {
			method: HttpRequestVerbs.POST,
			headers: {
				"Content-Type": `${HTTPrequestContentTypes.APPLICATION_JSON}; charset=${CHARSETS.UTF8}`,
			},
			body: JSON.stringify({
				clientCode: clientCode,
				saveAddress: saveImageOrVideoDataEndPoint,
			}),
		});
	} catch (e) {
		console.log(CAMERA_REQUEST_FAILED_ERROR, e);
	}
};

export const stopVideo = async () => {
	sendMultiScreenEventToTv(PlayerEvent.CLEAR_TV_MESSAGE);

	await fetch(stopRecordingVideoAndSaveItEndPoint, {
		method: HttpRequestVerbs.POST,
	});
};

export const useStartOrStopRecording = () => {
	const isVideoRecording = useSelector(isVideoRecordingSelector);
	const clientCode = useSelector(bamSessionClientCodeSelector);
	const roomId = useSelector(bamIdSelector);
	const dispatch = useDispatch();

	const startRecordingVideo = async () => {
		sendMultiScreenEventToTv(PlayerEvent.SHOW_VIDEO_TV_MESSAGE);

		await fetch(startRecordingVideoEndPoint, {
			method: HttpRequestVerbs.POST,
			headers: {
				"Content-Type": `${HTTPrequestContentTypes.APPLICATION_JSON}; charset=${CHARSETS.UTF8}`,
			},
			body: JSON.stringify({
				roomId,
				clientCode,
				saveAddress: saveImageOrVideoDataEndPoint,
			}),
		});
	};

	const startOrStop = isVideoRecording ? stopVideo : startRecordingVideo;

	return () => {
		try {
			startOrStop().then(() =>
				dispatch(setIsVideoRecording(!isVideoRecording)),
			);
		} catch (e) {
			console.log(CAMERA_REQUEST_FAILED_ERROR);
			console.log(e);
		}
	};
};
